<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__created_by><div class="table-default__left">Created by</div></template>
      <template #created_by="{ row }">
        <div class="table-default__left">
          <div v-if="row.created_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-end', offset: 10 }"
              >
            </div>
            {{ formatDateTime(row.created_at) }}
          </div>
        </div>
      </template>
      <template #file="{ row }">
        <div class="table-default__controls">
          <button
            @click="downloadFile(row)"
            type="button"
            :class="{'table-default__disabled': !row.file}"
          >
            <img src="@/assets/img/download-table-blue-icon.svg" alt="">
          </button>
        </div>
      </template>
      <template #rows="{ row }">{{ row.row_count }}</template>
      <template #status="{ row }">
        <span
          v-if="row.import_status === 'failed'"
          v-tooltip="{ content: row.import_error || 'Import failed', placement: 'top', offset: 10 }"
          class="import-status-error"
        >Failed ⓘ</span>
        <span v-else>{{ statusLabel(row.import_status) }}</span>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableDetailImports',
  props: ['tableItems', 'tablePreloader', 'pagination', 'formatDateTime', 'getUserAvatar', 'downloadFile'],
  data() {
    return {
      table: {
        columns: [
          'created_by',
          'file',
          'rows',
          'skipped',
          'status',
        ],
        options: {
          headings: {
            'created_by': 'Created by',
            'file': 'File',
            'rows': 'Rows',
            'skipped': 'Skipped',
            'status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  methods: {
    statusLabel(status) {
      return {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
      }[status] || status || 'Completed'
    },
  },
}
</script>

<style scoped>
.import-status-error {
  color: #c33;
  cursor: help;
}
</style>

